import { render, staticRenderFns } from "./JianHeLabelDialog.vue?vue&type=template&id=c6dde21c&scoped=true"
import script from "./JianHeLabelDialog.vue?vue&type=script&lang=js"
export * from "./JianHeLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./JianHeLabelDialog.vue?vue&type=style&index=0&id=c6dde21c&prod&scoped=true&lang=css"
import style1 from "./JianHeLabelDialog.vue?vue&type=style&index=1&id=c6dde21c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dde21c",
  null
  
)

export default component.exports